import { useState } from 'react';
import api from '../services/api';

export default function MernisQuery() {
  const [searchType, setSearchType] = useState('tc');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  
  // Form inputs
  const [tc, setTc] = useState('');
  const [gsm, setGsm] = useState('');
  const [adi, setAdi] = useState('');
  const [soyadi, setSoyadi] = useState('');

  const handleSearch = async () => {
    setLoading(true);
    setError('');
    setResult(null);
    
    try {
      let response;
      
      if (searchType === 'tc') {
        response = await api.post('/query/by-tc', { tc });
      } else if (searchType === 'gsm') {
        response = await api.post('/query/by-gsm', { gsm });
      } else {
        response = await api.post('/query/by-name', { adi, soyadi });
      }
      
      if (response.data.success) {
        setResult(response.data);
      } else {
        setError(response.data.error || 'Sonuç bulunamadı');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') handleSearch();
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-white mb-6">Mernis Sorgula</h1>
      
      {/* Search Type Tabs */}
      <div className="flex gap-2 mb-6">
        <button type="button"
          onClick={() => { setSearchType('tc'); setResult(null); setError(''); }}
          className={`px-4 py-2 rounded-lg font-medium transition ${
            searchType === 'tc' 
              ? 'bg-blue-600 text-white' 
              : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
          }`}
        >
          TC ile Ara
        </button>
        <button type="button"
          onClick={() => { setSearchType('gsm'); setResult(null); setError(''); }}
          className={`px-4 py-2 rounded-lg font-medium transition ${
            searchType === 'gsm' 
              ? 'bg-blue-600 text-white' 
              : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
          }`}
        >
          GSM ile Ara
        </button>
        <button type="button"
          onClick={() => { setSearchType('name'); setResult(null); setError(''); }}
          className={`px-4 py-2 rounded-lg font-medium transition ${
            searchType === 'name' 
              ? 'bg-blue-600 text-white' 
              : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
          }`}
        >
          Ad/Soyad ile Ara
        </button>
      </div>

      {/* Search Input */}
      <div className="bg-gray-800 rounded-xl p-6 mb-6">
        {searchType === 'tc' && (
          <div>
            <label className="block text-gray-400 mb-2">TC Kimlik No</label>
            <input
              type="text"
              value={tc}
              onChange={(e) => setTc(e.target.value.replace(/\D/g, '').slice(0, 11))}
              onKeyPress={handleKeyPress}
              placeholder="11 haneli TC giriniz"
              className="w-full md:w-96 px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg text-white focus:outline-none focus:border-blue-500"
              maxLength={11}
            />
          </div>
        )}
        
        {searchType === 'gsm' && (
          <div>
            <label className="block text-gray-400 mb-2">GSM Numarası</label>
            <input
              type="text"
              value={gsm}
              onChange={(e) => setGsm(e.target.value.replace(/\D/g, '').slice(0, 11))}
              onKeyPress={handleKeyPress}
              placeholder="05XX XXX XX XX"
              className="w-full md:w-96 px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg text-white focus:outline-none focus:border-blue-500"
              maxLength={11}
            />
          </div>
        )}
        
        {searchType === 'name' && (
          <div className="flex flex-col md:flex-row gap-4">
            <div>
              <label className="block text-gray-400 mb-2">Ad</label>
              <input
                type="text"
                value={adi}
                onChange={(e) => setAdi(e.target.value.toUpperCase())}
                onKeyPress={handleKeyPress}
                placeholder="Ad giriniz"
                className="w-full md:w-64 px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg text-white focus:outline-none focus:border-blue-500"
              />
            </div>
            <div>
              <label className="block text-gray-400 mb-2">Soyad</label>
              <input
                type="text"
                value={soyadi}
                onChange={(e) => setSoyadi(e.target.value.toUpperCase())}
                onKeyPress={handleKeyPress}
                placeholder="Soyad giriniz"
                className="w-full md:w-64 px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg text-white focus:outline-none focus:border-blue-500"
              />
            </div>
          </div>
        )}
        
        <button type="button"
          type="button" onClick={handleSearch}
          disabled={loading}
          className="mt-4 px-6 py-3 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-600 text-white font-medium rounded-lg transition"
        >
          {loading ? 'Aranıyor...' : 'Sorgula'}
        </button>
      </div>

      {/* Error */}
      {error && (
        <div className="bg-red-900/50 border border-red-700 text-red-300 px-4 py-3 rounded-lg mb-6">
          {error}
        </div>
      )}

      {/* Results */}
      {result && (
        <div className="bg-gray-800 rounded-xl p-6">
          <h2 className="text-lg font-semibold text-white mb-4">
            Sonuçlar {result.count && `(${result.count} kayıt)`}
          </h2>
          
          {/* Single result (TC search) */}
          {result.data && !Array.isArray(result.data) && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <InfoRow label="TC" value={result.data.tc} />
              <InfoRow label="Ad" value={result.data.adi} />
              <InfoRow label="Soyad" value={result.data.soyadi} />
              <InfoRow label="Doğum Tarihi" value={result.data.dogum_tarihi} />
              <InfoRow label="Anne Adı" value={result.data.anne_adi} />
              <InfoRow label="Baba Adı" value={result.data.baba_adi} />
              <InfoRow label="Nüfus İl" value={result.data.nufus_il} />
              <InfoRow label="Nüfus İlçe" value={result.data.nufus_ilce} />
              <div className="md:col-span-2">
                <InfoRow 
                  label="Telefonlar" 
                  value={result.data.telefonlar?.length > 0 
                    ? result.data.telefonlar.join(', ') 
                    : 'Kayıtlı telefon yok'
                  } 
                />
              </div>
            </div>
          )}
          
          {/* Multiple results (GSM/Name search) */}
          {result.data && Array.isArray(result.data) && (
            <div className="overflow-x-auto">
              <table className="w-full text-left">
                <thead>
                  <tr className="border-b border-gray-700">
                    <th className="px-4 py-3 text-gray-400">TC</th>
                    <th className="px-4 py-3 text-gray-400">Ad</th>
                    <th className="px-4 py-3 text-gray-400">Soyad</th>
                    <th className="px-4 py-3 text-gray-400">Doğum Tarihi</th>
                    {searchType === 'name' && (
                      <>
                        <th className="px-4 py-3 text-gray-400">İl</th>
                        <th className="px-4 py-3 text-gray-400">İlçe</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {result.data.map((item, idx) => (
                    <tr key={idx} className="border-b border-gray-700 hover:bg-gray-700/50">
                      <td className="px-4 py-3 text-white font-mono">{item.tc}</td>
                      <td className="px-4 py-3 text-white">{item.adi}</td>
                      <td className="px-4 py-3 text-white">{item.soyadi}</td>
                      <td className="px-4 py-3 text-gray-300">{item.dogum_tarihi}</td>
                      {searchType === 'name' && (
                        <>
                          <td className="px-4 py-3 text-gray-300">{item.nufus_il}</td>
                          <td className="px-4 py-3 text-gray-300">{item.nufus_ilce}</td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function InfoRow({ label, value }) {
  return (
    <div className="bg-gray-700/50 rounded-lg p-3">
      <div className="text-gray-400 text-sm">{label}</div>
      <div className="text-white font-medium">{value || '-'}</div>
    </div>
  );
}
